import { useState } from 'react';
import DealerTable from './DealerTable';
import UpdateDealer from './UpdateDealer';

const Dealers = () => {
    const [showUpdateDealer, setShowUpdateDealer] = useState(false);
    const [currentDealer, setCurrentDealer] = useState(null);

    // Forces dealer table to reload with new dealer
    const toggleShowUpdateDealer = () => setShowUpdateDealer(!showUpdateDealer);

    return (
        <div id="dealers-container">
            <h1>Dealers</h1>
            <DealerTable
                toggleShowUpdateDealer={toggleShowUpdateDealer}
                setCurrentDealer={setCurrentDealer} />
            <UpdateDealer
                showUpdateDealer={showUpdateDealer}
                currentDealer={currentDealer}
                toggleShowUpdateDealer={toggleShowUpdateDealer} />
        </div>
    );
}

export default Dealers;
